import { getRealmBonus } from "../spells/spells";
export function initFighting() {
    const points = {
        total: 0,
        actual: 0,
        malus: 0,
        death: 0,
        malusHit: 0,
        malusMagic: 0,
    };
    const fightingAttributes = {
        baseDefence: 0,
        totalDefense: 0,
        initiative: 0,
        destinityPoints: 0,
        resistance: 0,
        distanceMalus: 0,
        armorMalus: 0,
        bleading: 0,
        specialMalus: 0
    };
    const weaponCalculations = {
        onehandBlade: 0,
        onehandHit: 0,
        twohand: 0,
        rod: 0,
        distanceWeapon: 0,
        throwWeapon: 0
    };
    return {
        hits: points,
        magic: points,
        fightingAttributes,
        weaponCalculations
    };
}
const findById = (groups, id) => {
    const res = groups.filter(group => group.attribute.id == id);
    return res.length == 0 ? null : res[0];
};
function calcPointMalus(points, total) {
    if (points == 0 || points > total * 0.75)
        return 0;
    if (points > total * 0.5)
        return -10;
    if (points > total * 0.25)
        return -20;
    if (points <= total * 0.25)
        return -30;
    return -1000;
}
export function calcMagicPoints(chara) {
    // const total = findById(chara.groups,"15").attribute.total
    const total = getRealmBonus(chara) + findById(chara.groups, "15").attribute.total;
    const actual = total - chara.fightAttributes.magic.malus;
    const malus = chara.fightAttributes.magic.malus;
    const malusMagic = calcPointMalus(actual, total);
    return {
        total,
        actual,
        malus,
        malusMagic
    };
}
export function calcHitPoints(chara) {
    const total = findById(chara.groups, "8").attribute.total;
    const death = chara.characterAttributes.ko * 3 + total;
    const actual = total - chara.fightAttributes.hits.malus;
    const malus = chara.fightAttributes.hits.malus;
    const malusHit = calcPointMalus(actual, total);
    return {
        total,
        death,
        actual,
        malus,
        malusHit,
    };
}
/* todo waffen müssen zuerst implementiert werden
export function calculateWeaponValues(chara: Character):WeaponCalculations {
    
    return {
        onehandBlade: groups.find((g) => byId(g, "8")).attribute.total,
        onehandHit:,
        twohand:,
        rod:,
        distanceWeapon:,
        throwWeapon:
    }
}*/
